// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"18":"54804e18","106":"1e1ff8b5","297":"447d9569","829":"e84d1d3d"}[chunkId] + ".chunk.js";
};